// extracted by mini-css-extract-plugin
export default {"best":"styles_best__VH1iA"};